export const createUnknownError = () => new DOMException('', 'UnknownError');
